import i18n from '@/i18n'
import store from '@/store'

export const getTranslatedProperty = (property = {}) => {
  let translated

  const currentUserLanguage =
    store.getters['user/currentUserLanguage'] || i18n.locale || navigator.language.split('-')[0] || 'ru'

  if (currentUserLanguage === 'ru') {
    translated = property.name_ru
  } else {
    translated = property.name_en
  }

  return translated || property.name || ''
}
